import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  accountMode: 'view',
  invitationList: [] as string[],
  accountMembers: [] as {
    id: number;
    name: string;
    email: string;
    colorPill: {
      bgColor: string;
      color: string;
      borderColor: string;
    };
  }[],
  pendingMemberApprovals: [],
};

export const accountSlice = createSlice({
  name: 'posts',
  initialState,
  reducers: {
    setAccountMode: (state, action) => {
      state.accountMode = action.payload;
    },
    setInvitationList: (state, action) => ({
      ...state,
      invitationList: action.payload,
    }),
    setAccountMembers: (state, action) => ({
      ...state,
      accountMembers: action.payload,
    }),
    setPendingMemberApprovals: (state, action) => ({
      ...state,
      pendingMemberApprovals: action.payload,
    }),
  },
});

/** Action creators are generated for each case reducer function */
export const { setAccountMode, setInvitationList, setAccountMembers, setPendingMemberApprovals } =
  accountSlice.actions;

export default accountSlice.reducer;
